import { render, staticRenderFns } from "./pos-addinvoice.vue?vue&type=template&id=685426b8"
import script from "./pos-addinvoice.vue?vue&type=script&lang=js"
export * from "./pos-addinvoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports